import { Injectable } from '@angular/core';
import { BaseCrudService } from '../../../core/data/services/base-crud.service';
import ClaimRequest from '../../../core/data/models/claim.request.model';
import { CreateClaimRequestDto } from '../../../core/data/dtos/create.claim.request.dto';
import BaseResponse from '../../../core/data/models/baseModels/baseResponse.model';
import { RateClaimRequestDto } from '../../../core/data/dtos/rate.claim.request.dto';
import { RegisterBankAccountRequestDto } from '../../../core/data/dtos/register.bank.account.request.dto';

@Injectable()
export class ClaimRequestService extends BaseCrudService<ClaimRequest> {
  controller = 'ClaimRequests';
  getMyClaimsRequests(
    policyNumber?: string,
    insured?: number,
    dependent?: number,
  ) {
    return this.get<ClaimRequest[]>({ policyNumber, insured, dependent });
  }

  createClaimRequest(request: CreateClaimRequestDto) {
    return this.create<CreateClaimRequestDto, BaseResponse<any>>(
      request,
      undefined,
      undefined,
      false,
    );
  }

  registerBankAccount(request: RegisterBankAccountRequestDto) {
    return this.create<RegisterBankAccountRequestDto, BaseResponse<any>>(
      request,
      'clientfinantialinfo',
      undefined,
      false,
    );
  }

  rateClaimRequest(request: RateClaimRequestDto) {
    return this.create<RateClaimRequestDto, any>(
      request,
      'claimrequestrate',
      undefined,
      false,
    );
  }
}
